module.exports = __webpack_public_path__ + "img/hr-pipe-ending-down.99b2be4f.png";